function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.87,
    height: 7.77,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7769999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 3.885
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.77,
    width: 15.87,
    height: 8.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2457142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 12.129999999999999
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.5,
    width: 15.87,
    height: 8.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2514285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 20.88
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.26,
    width: 15.87,
    height: 9.33,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 29.925
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.58,
    width: 15.87,
    height: 11.21,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.40125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 40.185
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.8,
    width: 15.87,
    height: 11.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 51.455
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.1,
    width: 15.87,
    height: 13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 63.6
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70.1,
    width: 15.87,
    height: 13.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.652
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 76.72999999999999
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 83.36,
    width: 15.87,
    height: 13.65,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 90.185
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97.02,
    width: 15.87,
    height: 16.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.267142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 105.3
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 113.57,
    width: 15.87,
    height: 17.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.267142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 122.255
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.94,
    width: 15.87,
    height: 17.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.267142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 139.63
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 148.32,
    width: 15.87,
    height: 20.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 158.76999999999998
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 169.22,
    width: 15.87,
    height: 21.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 179.825
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 190.44,
    width: 15.87,
    height: 21.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 201.195
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 211.95,
    width: 15.87,
    height: 22.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 223.255
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 234.56,
    width: 15.87,
    height: 22.82,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 245.97
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.38,
    width: 15.87,
    height: 23.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 269.005
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.64,
    width: 15.87,
    height: 24.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 293.06
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.48,
    width: 15.87,
    height: 25.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 317.995
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330.51,
    width: 15.87,
    height: 25.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 343.14
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 355.76,
    width: 15.87,
    height: 27.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.267142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 369.27
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 382.79,
    width: 15.87,
    height: 27.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 396.37
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.95,
    width: 15.87,
    height: 27.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.267142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 423.775
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 437.6,
    width: 15.87,
    height: 27.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 451.56
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 465.52,
    width: 15.87,
    height: 28.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 479.59999999999997
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.68,
    width: 15.87,
    height: 28.21,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.587
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 507.785
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.89,
    width: 15.87,
    height: 28.66,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.267142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 536.22
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 550.55,
    width: 15.87,
    height: 29.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 565.0649999999999
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.57,
    width: 15.87,
    height: 29.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 594.1
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 608.63,
    width: 15.87,
    height: 30.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 623.705
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 638.78,
    width: 15.87,
    height: 30.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 653.915
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 669.05,
    width: 15.87,
    height: 30.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.935,
    y: 684.525
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 0,
    width: 19.98,
    height: 24.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8542857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 25.86,
    y: 12.355
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.85,
    y: 0,
    width: 20.2,
    height: 24.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.95,
    y: 12.355
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.05,
    y: 0,
    width: 20.98,
    height: 24.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.196
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.53999999999999,
    y: 12.355
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.03,
    y: 0,
    width: 21.33,
    height: 24.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.266
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.695,
    y: 12.355
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.36,
    y: 0,
    width: 21.92,
    height: 24.71,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1314285714285717
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.32,
    y: 12.355
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.28,
    y: 0,
    width: 22.06,
    height: 24.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1514285714285712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.31,
    y: 12.355
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.35,
    y: 0,
    width: 22.29,
    height: 24.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.184285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 153.495,
    y: 12.355
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.64,
    y: 0,
    width: 22.31,
    height: 24.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.187142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.795,
    y: 12.355
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.94,
    y: 0,
    width: 22.8,
    height: 24.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8000000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.34,
    y: 12.355
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.74,
    y: 0,
    width: 23.59,
    height: 24.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.621111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.535,
    y: 12.355
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.33,
    y: 0,
    width: 25.13,
    height: 24.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.942
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.895,
    y: 12.355
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.46,
    y: 0,
    width: 25.51,
    height: 24.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.118333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.215,
    y: 12.355
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.97,
    y: 0,
    width: 25.63,
    height: 24.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.08875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.785,
    y: 12.355
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.6,
    y: 0,
    width: 26.46,
    height: 24.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.08875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.83000000000004,
    y: 12.355
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.06,
    y: 0,
    width: 26.65,
    height: 24.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.471
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.385,
    y: 12.355
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.71,
    y: 0,
    width: 26.94,
    height: 24.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.942
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.18,
    y: 12.355
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.65,
    y: 0,
    width: 29.06,
    height: 24.71,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.942
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.17999999999995,
    y: 12.355
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.71,
    y: 0,
    width: 29.79,
    height: 24.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.60499999999996,
    y: 12.355
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.51,
    y: 0,
    width: 29.8,
    height: 24.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.118333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.40999999999997,
    y: 12.355
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.31,
    y: 0,
    width: 30.74,
    height: 24.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.08875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.68,
    y: 12.355
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.05,
    y: 0,
    width: 31.28,
    height: 24.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.118333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.69,
    y: 12.355
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.33,
    y: 0,
    width: 31.44,
    height: 24.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.08875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.0500000000001,
    y: 12.355
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.77,
    y: 0,
    width: 31.51,
    height: 24.71,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.942
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.525,
    y: 12.355
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.28,
    y: 0,
    width: 31.7,
    height: 24.71,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.08875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.13,
    y: 12.355
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.98,
    y: 0,
    width: 32.48,
    height: 24.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.22,
    y: 12.355
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.46,
    y: 0,
    width: 32.54,
    height: 24.71,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5300000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.73,
    y: 12.355
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 24.71,
    width: 30.38,
    height: 26.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6510000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 37.965
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 51.22,
    width: 30.38,
    height: 26.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.801428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 64.525
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 77.83,
    width: 30.38,
    height: 27.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.44875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 91.625
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 105.42,
    width: 30.38,
    height: 27.88,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 119.36
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 133.3,
    width: 30.38,
    height: 28.72,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.102857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 147.66000000000003
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 162.03,
    width: 30.38,
    height: 29.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2977777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 176.87
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 191.7,
    width: 30.38,
    height: 30.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 207.195
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 222.69,
    width: 30.38,
    height: 31.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 238.345
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 254,
    width: 30.38,
    height: 31.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 269.805
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 285.6,
    width: 30.38,
    height: 32.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 301.845
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 318.1,
    width: 30.38,
    height: 33.24,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 334.72
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 351.33,
    width: 30.38,
    height: 33.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 368.01
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 384.69,
    width: 30.38,
    height: 33.72,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 401.55
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 418.41,
    width: 30.38,
    height: 33.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 435.27500000000003
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 452.15,
    width: 30.38,
    height: 33.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 469.075
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 485.99,
    width: 30.38,
    height: 34.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 503.08
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 520.17,
    width: 30.38,
    height: 34.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3755555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 537.27
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 554.37,
    width: 30.38,
    height: 34.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 571.5600000000001
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 588.75,
    width: 30.38,
    height: 36.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.038
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 606.96
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 625.17,
    width: 30.38,
    height: 37.34,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 643.8399999999999
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.87,
    y: 662.51,
    width: 30.38,
    height: 37.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.06,
    y: 681.255
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 24.71,
    width: 32.37,
    height: 35.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.395
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.435,
    y: 42.35
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.61,
    y: 24.71,
    width: 33.09,
    height: 35.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.618
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.155,
    y: 42.35
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.71,
    y: 24.71,
    width: 33.39,
    height: 35.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.17375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.405,
    y: 42.35
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 24.71,
    width: 33.61,
    height: 35.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3609999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.905,
    y: 42.35
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.71,
    y: 24.71,
    width: 34.03,
    height: 35.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.806
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.72500000000002,
    y: 42.35
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.74,
    y: 24.71,
    width: 34.27,
    height: 35.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.711666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.875,
    y: 42.35
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.01,
    y: 24.71,
    width: 35.26,
    height: 35.28,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.876666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.64,
    y: 42.35
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.27,
    y: 24.71,
    width: 35.4,
    height: 35.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.96999999999997,
    y: 42.35
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.67,
    y: 24.71,
    width: 36.67,
    height: 35.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.005,
    y: 42.35
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.35,
    y: 24.71,
    width: 37.26,
    height: 35.28,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.98,
    y: 42.35
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.61,
    y: 24.71,
    width: 37.34,
    height: 35.28,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.056
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.28000000000003,
    y: 42.35
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.96,
    y: 24.71,
    width: 37.58,
    height: 35.28,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.75,
    y: 42.35
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.54,
    y: 24.71,
    width: 37.75,
    height: 35.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.056
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.415,
    y: 42.35
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.29,
    y: 24.71,
    width: 38.14,
    height: 35.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.056
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.36,
    y: 42.35
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.43,
    y: 24.71,
    width: 39.23,
    height: 35.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.045,
    y: 42.35
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.65,
    y: 24.71,
    width: 39.3,
    height: 35.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.3,
    y: 42.35
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.96,
    y: 24.71,
    width: 39.5,
    height: 35.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.71,
    y: 42.35
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.46,
    y: 24.71,
    width: 39.54,
    height: 35.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.056
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.23,
    y: 42.35
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 60,
    width: 40.45,
    height: 35.01,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.001428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 77.505
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 95.01,
    width: 40.45,
    height: 35.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 112.62
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 130.23,
    width: 40.45,
    height: 35.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.876666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 147.85999999999999
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 165.49,
    width: 40.45,
    height: 37.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.236666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 184.20000000000002
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 202.9,
    width: 40.45,
    height: 37.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.291666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 221.775
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 240.65,
    width: 40.45,
    height: 38.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 259.805
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 278.96,
    width: 40.45,
    height: 38.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.676
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 298.15
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 317.34,
    width: 40.45,
    height: 39.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.638571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 337.075
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 356.8,
    width: 40.45,
    height: 39.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.926
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 376.615
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 396.44,
    width: 40.45,
    height: 40.39,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.463333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 416.635
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 436.83,
    width: 40.45,
    height: 41.44,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.05625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 457.54999999999995
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 478.27,
    width: 40.45,
    height: 42.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.741666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 499.46
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 520.65,
    width: 40.45,
    height: 43.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 542.4499999999999
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 564.24,
    width: 40.45,
    height: 43.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 586.215
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 608.2,
    width: 40.45,
    height: 45.77,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4944444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 631.085
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 653.97,
    width: 40.45,
    height: 46.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.741666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.475,
    y: 676.985
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 60,
    width: 42.09,
    height: 48.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.012857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.745,
    y: 84.275
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.79,
    y: 60,
    width: 42.51,
    height: 48.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.072857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.045,
    y: 84.275
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.31,
    y: 60,
    width: 43.91,
    height: 48.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3183333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.265,
    y: 84.275
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.22,
    y: 60,
    width: 44.08,
    height: 48.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.346666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.26,
    y: 84.275
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.3,
    y: 60,
    width: 45.31,
    height: 48.55,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.551666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.95500000000004,
    y: 84.275
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.61,
    y: 60,
    width: 47.47,
    height: 48.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.911666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.345,
    y: 84.275
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.08,
    y: 60,
    width: 51.24,
    height: 48.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.7,
    y: 84.275
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.32,
    y: 60,
    width: 52.21,
    height: 48.55,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.394444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.425,
    y: 84.275
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.52,
    y: 60,
    width: 59.07,
    height: 48.55,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.055,
    y: 84.275
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.6,
    y: 60,
    width: 60.71,
    height: 48.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.091666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 544.955,
    y: 84.275
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.31,
    y: 60,
    width: 61.54,
    height: 48.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.0799999999999,
    y: 84.275
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.85,
    y: 60,
    width: 63.15,
    height: 48.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.4250000000001,
    y: 84.275
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 108.55,
    width: 59.38,
    height: 51.69,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 134.39499999999998
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 160.24,
    width: 59.38,
    height: 53.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 186.78
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 213.32,
    width: 59.38,
    height: 54.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.940000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 240.67
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 268.02,
    width: 59.38,
    height: 58.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 297.18
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 326.34,
    width: 59.38,
    height: 70.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.876000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 361.39
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 396.44,
    width: 59.38,
    height: 72.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.876000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 432.45
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 468.46,
    width: 59.38,
    height: 75.71,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.896666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 506.315
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 544.17,
    width: 59.38,
    height: 76.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.896666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 582.4399999999999
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 620.71,
    width: 59.38,
    height: 79.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.39,
    y: 660.355
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.08,
    y: 108.55,
    width: 67.79,
    height: 71.47,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.532222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.97500000000002,
    y: 144.285
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.87,
    y: 108.55,
    width: 68.71,
    height: 71.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.815714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.225,
    y: 144.285
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.59,
    y: 108.55,
    width: 72.32,
    height: 71.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.911666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.75,
    y: 144.285
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.91,
    y: 108.55,
    width: 75.74,
    height: 71.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.209999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.78000000000003,
    y: 144.285
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.65,
    y: 108.55,
    width: 79.61,
    height: 71.47,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.911666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.455,
    y: 144.285
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.26,
    y: 108.55,
    width: 93.51,
    height: 71.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.911666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.015,
    y: 144.285
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.77,
    y: 108.55,
    width: 96.23,
    height: 71.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.209999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.885,
    y: 144.285
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.08,
    y: 180.02,
    width: 84.97,
    height: 81.34,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.565,
    y: 220.69
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.08,
    y: 261.35,
    width: 84.97,
    height: 82.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.73857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.565,
    y: 302.435
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.08,
    y: 343.52,
    width: 84.97,
    height: 83.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.565,
    y: 385.37
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.08,
    y: 427.22,
    width: 84.97,
    height: 87.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.138571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.565,
    y: 470.805
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.08,
    y: 514.38,
    width: 84.97,
    height: 88.18,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.2425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.565,
    y: 558.47
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.08,
    y: 602.56,
    width: 84.97,
    height: 97.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.2425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.565,
    y: 651.28
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.05,
    y: 180.02,
    width: 84.52,
    height: 109.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.31,
    y: 234.685
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.57,
    y: 180.02,
    width: 86.05,
    height: 109.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.292857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.59499999999997,
    y: 234.685
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.62,
    y: 180.02,
    width: 90.52,
    height: 109.33,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.88,
    y: 234.685
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.14,
    y: 180.02,
    width: 100.75,
    height: 109.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.515,
    y: 234.685
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.89,
    y: 180.02,
    width: 107.11,
    height: 109.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.38875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.4449999999999,
    y: 234.685
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.05,
    y: 289.35,
    width: 151.99,
    height: 81.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.655714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.045,
    y: 330.14500000000004
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.05,
    y: 370.93,
    width: 151.99,
    height: 90.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.934285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.045,
    y: 416.2
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.05,
    y: 461.48,
    width: 151.99,
    height: 238.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.99875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.045,
    y: 580.74
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.04,
    y: 289.35,
    width: 156.81,
    height: 251.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.44500000000005,
    y: 414.94500000000005
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.85,
    y: 289.35,
    width: 160.15,
    height: 251.19,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.691666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.9250000000001,
    y: 414.94500000000005
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.04,
    y: 540.54,
    width: 316.96,
    height: 159.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.576666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.52,
    y: 620.27
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2008);
export default __webpack_public_path__ + "static/media/2008.4947b21e16bf4c5287942df19d6081c1.svg";
export { ForwardRef as ReactComponent };